<div class="fluid" >
    <router-outlet></router-outlet>
</div>